<template>
  <div class="mapboxgl-custom-input">
    <!-- Radio inputs -->
    <v-card flat class="input-container">
      <v-card-text>

        <v-layout row wrap>
          <v-flex xs12>
            <h5 class="body-1 font-weight-bold mb-3">
              Click to see countries that have made commitments with China for the BRI.
            </h5>
          </v-flex>

          <v-flex xs12>
            <h4 class="body-2 font-weight-bold">Terms of Agreement (Bilateral)</h4>

            <v-radio-group v-model="diplomacy" @change="updateDiplomacyState">
              <v-radio v-for="term in bilateral" :key="term.value" :label="term.value" :value="term.value" :color="term.color" />
            </v-radio-group>
          </v-flex>

          <v-flex xs12>
            <h4 class="body-2 font-weight-bold">Organisations (Multilateral)</h4>

            <v-radio-group hide-details v-model="diplomacy" @change="updateDiplomacyState">
              <v-radio v-for="organisation in multilateral" :key="organisation.value" :label="organisation.label" :value="organisation.value" :color="organisation.color" />
            </v-radio-group>
          </v-flex>
        </v-layout>

      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'InputDiplomacy',
  data() {
    return {
      bilateral: [
        { value: 'Memorandum of Understanding', color: 'primary' },
        { value: 'Free Trade Agreement', color: 'primary' },
        { value: 'Strategic Partnership', color: 'primary' },
        { value: 'Bilateral Agreement', color: 'primary' },
        { value: 'Partnership', color: 'primary' },
        { value: 'Talks', color: 'primary' },
      ],
      multilateral: [
        { label: '16+1', value: '16_1', color: 'primary' },
        { label: 'BRICS', value: 'BRICS', color: 'primary' },
        { label: 'Lancang-Mekong Cooperation', value: 'Lancang_Me', color: 'primary' },
        { label: 'Shanghai Cooperation Organisation', value: 'Shanghai_C', color: 'primary' },
      ],
    };
  },
  computed: {
    diplomacy: {
      get() {
        return this.$store.getters['viewDiplomacy/selectedDiplomacy'];
      },
      set(value) {
        this.$store.dispatch('viewDiplomacy/updateDiplomacy', value);
      },
    },
  },
  methods: {
    updateDiplomacyState(value) {
      // multilateral organisations
      let multilateral = ['16_1', 'BRICS', 'Lancang_Me', 'Shanghai_C'];

      // check which type it belongs to
      const layerId = multilateral.includes(value) ? 'multilateral' : 'bilateral';

      // update state diplomacy type
      this.$store.dispatch('viewDiplomacy/updateType', layerId);
    },
  },
};
</script>

<style lang="stylus" scoped>
.input-container {
  max-width: 19vw;
  background-color: #F8F4EE !important;

  h5 {
    line-height: 1.4;
  }

  >>>.v-icon {
    color: rgba(0, 0, 0, 0.3);
    font-size: 19px;
  }
}
</style>
